import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { JobAlertRulesService } from 'src/app/recruiting/dashboard/job-alert-rules.service';
import { RecruitingEffects } from 'src/app/recruiting/store/recruiting.effects';
import { RecruitingReducers } from 'src/app/recruiting/store/recruiting.reducers';
import { RecruitingFeatureKey } from 'src/app/recruiting/store/recruiting.selectors';

@NgModule({
    imports: [
        StoreModule.forFeature(RecruitingFeatureKey, RecruitingReducers),
        EffectsModule.forFeature(RecruitingEffects)
    ],
    providers: [JobAlertRulesService]
})
export class RecruitingJobsStoreModule {}
